import { useEffect, useState } from 'react';

/** Phone breakpoint — single-pane navigation + drawers below this width. */
export const MOBILE_QUERY = '(max-width: 640px)';

/** Reactive `true` when the viewport is phone-sized. SSR-safe (defaults false). */
export function useIsMobile(query: string = MOBILE_QUERY): boolean {
  const [match, setMatch] = useState<boolean>(() =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false,
  );
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatch(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);
  return match;
}
